export default __webpack_public_path__ + "locales/sr-Latn-RS/SendInviteDialog.json?hash=458168c0715e93d795fb9a3cea84f1b2";